import documentsRoutingKeys from "Areas/Documents/routingKeys";
import settingsRoutingKeys from "Areas/Settings/routingKeys";
import { REDUX_ROUTING_PAGE_NAMESPACE, routesAndPagesMap } from "Common/routingUtils";
import get from "lodash/get";
import includes from "lodash/includes";
import values from "lodash/values";
import { createSelector } from "reselect";
import { getIsExpanded as getIsDocumentsMenuExpanded } from "../../Documents";
import { getIsExpanded as getIsSettingsMenuExpanded } from "../../Settings";
import { NAMESPACE } from "../../constants";
export const getIsSidebarExpanded = createSelector((state) => get(state, `[${REDUX_ROUTING_PAGE_NAMESPACE}].key`), (state) => getIsDocumentsMenuExpanded(state), (state) => getIsSettingsMenuExpanded(state), (routingPage, isDocumentsMenuExpanded, isSettingsMenuExpanded) => {
    if (includes(values(documentsRoutingKeys), routingPage))
        return isDocumentsMenuExpanded;
    if (includes(values(settingsRoutingKeys), routingPage))
        return isSettingsMenuExpanded;
    return true;
});
export const getBackUrlHash = createSelector((state) => get(state, `[${NAMESPACE}].backUrlHash`), (backUrlHash) => backUrlHash !== null && backUrlHash !== void 0 ? backUrlHash : routesAndPagesMap.getDefaultHref());
